
import { AuthUiConfig } from './auth-ui.config';
import { LoginResponse } from 'lib-klab-core';

export function collectMenuCodes(session: LoginResponse): Set<string> {
    const codes = new Set<string>();

    const walk = (items: any[]) => {
        for (const it of items ?? []) {
            const code = String(it?.code ?? '').trim();
            if (code) codes.add(code);

            const children = Array.isArray(it?.children) ? it.children : [];
            walk(children.filter((c: any) => typeof c === 'object' && c !== null));
        }
    };

    walk(session?.menu ?? []);
    return codes;
}

export function isSessionAllowed(session: LoginResponse, cfg: AuthUiConfig): boolean {
    const access = cfg.access;

    if (!access) return true;

    const roleId = Number(session?.user?.role?.role_id);
    const roleName = String(session?.user?.role?.name ?? '').trim().toLowerCase();
    const menuCodes = collectMenuCodes(session);

    const hasAnyRule = Boolean(
        access.allowedRoleIds?.length ||
        access.allowedRoleNames?.length ||
        access.requiredAnyPermissions?.length
    );

    if (!hasAnyRule) return true;

    if (access.allowedRoleIds?.length && access.allowedRoleIds.includes(roleId)) return true;

    if (access.allowedRoleNames?.length) {
        const allowedNames = access.allowedRoleNames.map(n => String(n).trim().toLowerCase());
        if (allowedNames.includes(roleName)) return true;
    }

    if (access.requiredAnyPermissions?.length) {
        if (access.requiredAnyPermissions.some(code => menuCodes.has(code))) return true;
    }

    return false;
}

export function resolveRedirectIam(opts: {
    session: LoginResponse;
    cfg: AuthUiConfig;
    redirectFromGuard?: string | null;
}): string {
    const { session, cfg, redirectFromGuard } = opts;

    if (redirectFromGuard) return redirectFromGuard;

    const custom = cfg.resolveRedirect?.(session);
    if (custom) return custom;

    const roleId = Number(session?.user?.role?.role_id);
    const roleName = String(session?.user?.role?.name ?? '').trim();

    if (cfg.redirectByRoleId?.[roleId]) return cfg.redirectByRoleId[roleId];
    if (cfg.redirectByRoleName?.[roleName]) return cfg.redirectByRoleName[roleName];

    if (cfg.redirectByPermission) {
        const codes = collectMenuCodes(session);
        for (const [perm, url] of Object.entries(cfg.redirectByPermission)) {
            if (codes.has(perm)) return url;
        }
    }

    return cfg.postLoginRedirectUrl ?? '/';
}
